import { AppStyle } from "./appStyle";
import { env } from "../env";

export const basePath: string = env.REACT_APP_API_URL;
export const basePathWithApi: string = basePath + "/api/v1.8";
export const filesUri: string = basePathWithApi + "/Files";
export const imagesUri: string = filesUri + "/images";
export const refreshTokenUri: string = basePathWithApi + "/Customers/refreshToken";

export const apiKey: string = env.REACT_APP_API_KEY;

export const appStyleMode: AppStyle =
    env.REACT_APP_TYPE === "mobile" ? AppStyle.Mobile :
        env.REACT_APP_COMPANY_NAME === "FORMADA" ? AppStyle.Formada :
            AppStyle.Website;

export const CompanyName: string = env.REACT_APP_COMPANY_NAME;
export const CompanyRegistered: string = env.REACT_APP_COMPANY_REGISTERED;
export const CompanyTitle: string = env.REACT_APP_OG_TITLE;
export const SiteName: string = env.REACT_APP_SITE_NAME;
export const AppUrl: string = env.REACT_APP_OG_URL;
export const IsSewingCompany: boolean = appStyleMode === AppStyle.Formada;
export const IsGtagEnabled: boolean = !!env.REACT_APP_GOOGLE_TAG_ID;

export const ExternalLoginPrefix: string = env.REACT_APP_EXTERNAL_LOGIN_PREFIX;
export const FacebookUrl: string = env.REACT_APP_LINK_FACEBOOK;
export const InstagramUrl: string = env.REACT_APP_LINK_INSTAGRAM;
export const YoutubeUrl: string = env.REACT_APP_LINK_YOUTUBE;